import styled from 'styled-components'

import RotateIcon from 'assets/svgr-icons/Rotate.svg'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const PositionedMediaControlsHost = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  /* Let drags pass through to CanvasItemFrame / Moveable; only the toolbar captures. */
  pointer-events: none;
`

export const CounterScaleWrapper = styled.div<{ $inverseScale: number }>`
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: top left;
  transform: scale(${({ $inverseScale }) => $inverseScale});
  pointer-events: none;
`

export const MediaControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  gap: 6px;
  background-color: ${COLORS.white};
  border-radius: 4px;
  transform: translateY(calc(-100% - 4px));
  transform-origin: top left;
  pointer-events: auto;
  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding: 4px;
  }
`

export const MediaControlItem = styled.div<{
  $disabled?: boolean
  $isActive?: boolean
}>`
  width: 32px;
  height: 24px;
  padding: 4px 8px;
  box-sizing: border-box;
  background-color: ${COLORS.white};
  border-radius: 4px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};

  /* Toolbar icon tint: inherited as currentColor (see Layer_order.svg path fill) */
  color: ${COLORS.secondarySemiDark};

  svg {
    fill: currentColor;
  }

  &:hover {
    background-color: ${({ $disabled }) =>
      $disabled ? COLORS.white : COLORS.primaryLight};

    color: ${({ $disabled }) =>
      $disabled ? COLORS.secondarySemiDark : COLORS.secondaryDark};
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    outline: 1px solid ${COLORS.primaryDark};
    background-color: ${COLORS.primaryLight};
  `}
`

export const MediaControlDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${COLORS.borderColor};
`

export const RotateRightIcon = styled(RotateIcon)`
  transform: scaleX(-1);
`
